export const LAB_COMPLETED_MESSAGE = 'idcoder-lab-completed';

export function notifyLabCompleted(labId: number, courseId: number | null) {
  try {
    window.opener?.postMessage(
      { type: LAB_COMPLETED_MESSAGE, labId, courseId },
      window.location.origin
    );
  } catch {
    /* opener may be cross-origin */
  }
  if (window.opener) {
    window.close();
  }
}

export function onLabCompletedMessage(handler: (labId: number, courseId: number | null) => void) {
  const listener = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type !== LAB_COMPLETED_MESSAGE) return;
    handler(Number(event.data.labId), event.data.courseId ?? null);
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
